import React  from 'react';
import style from './style.module.css'

const Error404 = () => <div className={style.container}>
    <div className={style.code}>4<span style={{ color: '#FFBD13' }}>0</span>4</div>
    <div>такой страницы не существует</div>
  </div>

export default Error404
